import { companiesConstants } from '../constants';
import {userConstants} from "../../auth/constants";

const initialState = {
  currentCompany: {}
};

export const companies = (state = initialState, { type, payload }) => {
  switch (type) {
    case companiesConstants.SET_CURRENT_COMPANY:
      return {
        ...state,
        currentCompany: payload,
      };
    case userConstants.REQUEST_LOGOUT_FINISHED:
      return initialState;
    default:
      return state
  }
};